import React from "react";

import Close from "../../../images/close-white.png";

function PaymentRejectModal(props) {
  return (
    <div
      className="modal fade"
      id="paymentRejectModal"
      tabIndex="-1"
      aria-labelledby="paymentRejectModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="paymentRejectModalLabel">
              Are you sure?
            </h5>

            <img
              src={Close}
              alt="close"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              width="50px"
              style={{ cursor: "pointer" }}
              id="paymentRejectModalClose"
            />
          </div>
          <div className="modal-body">
            <p>Do you want to reject this payment?</p>
          </div>
          <div className="modal-footer border-0 p-2">
            <button type="button" className="btn" data-dismiss="modal">
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() =>
                props.handleApprove(props.scanId, props.agentCode, false)
              }
              style={{ width: 95 }}
            >
              {props.loading ? (
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              ) : (
                "Reject"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentRejectModal;
